import { Project, ProjectDetails } from '../types';

import { isDraft, isPublished } from './helpers';
import { technologyTransformer } from './technology-transformer';

export function projectDetailsTransformer(project?: Project): ProjectDetails | null {
  if (!project) return null;

return {
    id: project.id,
    company: project.company,
    location: {
      country: project.country,
      city: [project.city],
    },
    technologies: project.technologies.map(technologyTransformer),
    isPublished: isPublished(project.status),
    isDraft: isDraft(project.status),
    otherDetails: project.other_details,
    permits: project?.permits,
    permitsComments: project?.permits_comments,
    connectionInfrastructure: project.connection_infrastructure,
    landRights: project.land_rights,
    capexAndOpex: project.capex_and_opex,
    otherInfo: project.other_info,
    name: project.name,
    portfolioSummary: project.portfolio_summary,
    financialHighlights: project.financial_highlights,
    teamGovernance: project.team_and_governance,
  };
}
